
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 23"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.468 7.395l-.002.002-.003.002.005-.004zm9.954-.187a1.238 1.238 0 00-.23-.175 1 1 0 00-1.4.411 5.783 5.783 0 01-1.397 1.778A8.714 8.714 0 008.128.13a1 1 0 00-1.492.806 7.017 7.017 0 01-2.471 4.942l-.23.188a8.513 8.513 0 00-1.988 1.862 8.983 8.983 0 003.656 13.908 1 1 0 001.327-1.238 6.977 6.977 0 01-.19-2.581 9.004 9.004 0 004.313 4.016c.225.101.48.115.715.038a8.995 8.995 0 003.654-14.863zM11.517 20.04a6.962 6.962 0 01-3.577-4.402 8.908 8.908 0 01-.18-.964 1 1 0 00-1.857-.362 8.959 8.959 0 00-1.205 4.718A6.986 6.986 0 013.522 9.16a6.555 6.555 0 011.562-1.458.745.745 0 00.075-.054s.296-.246.307-.251a8.968 8.968 0 002.898-4.633 6.736 6.736 0 011.386 8.088 1 1 0 001.184 1.418 7.856 7.856 0 003.862-2.688 7.002 7.002 0 01-3.279 10.457z","fill":"#D8F3DC"}})])
          )
        }
      }
    